import PropTypes from 'prop-types';
import React from 'react';
import FindOntologyRelatedResourceDialog from '../../application-core/FindOntologyRelatedResourceDialog';

class FindOntologyRelatedConceptPassthroughDialog extends React.Component {

    render() {

        return (
            <FindOntologyRelatedResourceDialog
                {...this.props}
                mode={{
                    allowLangSelection: false,
                    searchType: "http://www.w3.org/2004/02/skos/core#Concept",
                    searchIn: "http://www.w3.org/2004/02/skos/core#inScheme",
                    searchLabel: "http://www.w3.org/2004/02/skos/core#prefLabel",
                }} />
        );
    }
}

FindOntologyRelatedConceptPassthroughDialog.propTypes = {
    component: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.object
    ])
};

export default FindOntologyRelatedConceptPassthroughDialog;